import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type RefreshUserClaimsMutationVariables = Types.Exact<{
  userId: Types.Scalars['bigint']['input'];
}>;


export type RefreshUserClaimsMutation = { __typename?: 'mutation_root', update_users?: { __typename?: 'users_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'users', id: number, updated_at: string }> } | null };


export const RefreshUserClaimsDocument = gql`
    mutation refreshUserClaims($userId: bigint!) {
  update_users(where: {id: {_eq: $userId}}, _set: {updated_at: "now()"}) {
    affected_rows
    returning {
      id
      updated_at
    }
  }
}
    `;
export type RefreshUserClaimsMutationFn = Apollo.MutationFunction<RefreshUserClaimsMutation, RefreshUserClaimsMutationVariables>;

/**
 * __useRefreshUserClaimsMutation__
 *
 * To run a mutation, you first call `useRefreshUserClaimsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRefreshUserClaimsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [refreshUserClaimsMutation, { data, loading, error }] = useRefreshUserClaimsMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRefreshUserClaimsMutation(baseOptions?: Apollo.MutationHookOptions<RefreshUserClaimsMutation, RefreshUserClaimsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RefreshUserClaimsMutation, RefreshUserClaimsMutationVariables>(RefreshUserClaimsDocument, options);
      }
export type RefreshUserClaimsMutationHookResult = ReturnType<typeof useRefreshUserClaimsMutation>;
export type RefreshUserClaimsMutationResult = Apollo.MutationResult<RefreshUserClaimsMutation>;
export type RefreshUserClaimsMutationOptions = Apollo.BaseMutationOptions<RefreshUserClaimsMutation, RefreshUserClaimsMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/userManagement/queries/refreshClaims.mutation.gql}
 */
export async function refreshUserClaims(
  variables: RefreshUserClaimsMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<RefreshUserClaimsMutation['update_users']>
export async function refreshUserClaims(
  variables: RefreshUserClaimsMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<RefreshUserClaimsMutation>
export async function refreshUserClaims(
  variables: RefreshUserClaimsMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<RefreshUserClaimsMutation['update_users'] | RefreshUserClaimsMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<RefreshUserClaimsMutation>(
    RefreshUserClaimsDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_users
}